import React, { Fragment, useEffect, Dispatch, SetStateAction, useState } from 'react'
import { useModal } from 'react-hooks-use-modal';
import { useForm, SubmitHandler } from "react-hook-form";
import { useAuth } from '../hooks/use-auth';
import axios from 'axios';
import IdSearchButton from './IdSearchButton';
import { removeKeyWithValue } from 'utils';
import config from 'config';
import { ModalStyle, FormLabel, FormInput, FormLabelInputWrapper, ModalTitle, ModalForm, ModalSubmit, LoadingContainer, ModalClose } from 'styles/styles';
import { CircularProgress } from '@mui/material';

interface Props {
  process_id: number,
  volume: number,
  process_deadline: string,
  process_name: string,
  isModalOpen: boolean,
  setIsModalOpen: Dispatch<SetStateAction<boolean>>;
  setIsDataInsert: Dispatch<SetStateAction<boolean>>;
}

interface ParentDataProps {
  process_id: number,
  supplier_id: number,
  supplier_display_id: string,
  order_number: number,
  internal_deadline: string,
  product_name: string,
  customer_factory_name: string
  memo: string,
  created_by: number,
  updated_by: number
  [key: string]: string | number;
}

const ShareProcesses = ({ process_id, volume, process_deadline, process_name, isModalOpen, setIsModalOpen, setIsDataInsert }: Props) => {
  const auth = useAuth();
  const [isSubmitDisable, setIsSubmitDisable] = useState<boolean>(false);
  //modal
  const modalTitle = "工程共有";
  const [Modal, open, close, isOpen] = useModal('root', { preventScroll: true, });
  const { reset, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<ParentDataProps>();
  const onSubmit: SubmitHandler<ParentDataProps> = async (submitData: ParentDataProps) => {
    let alertList: any[] = [];
    const requiredFields = parentArray.filter(obj => obj.required === true).map(obj => obj.field);
    requiredFields.forEach((key) => {
      if (submitData[key] === undefined) {
        alertList.push(key)
      }
    });
    if (alertList.length) {
      let text = '';
      parentArray.forEach(item => {
        if (alertList.includes(item.field)) {
          text += `${item.title}を埋めてください。\n`;
        }
      });
      if (text !== '') {
        alert(text);
        throw new Error('必須項目が未入力です');
      }
    }

    submitData = removeKeyWithValue(submitData, '');
    const branchData = {
      process_id: process_id,
      supplier_id: submitData.supplier_id,
      order_number: submitData.order_number,
      internal_deadline: submitData.internal_deadline,
      product_name: submitData.product_name,
      customer_factory_name: submitData.customer_factory_name,
      memo: submitData.memo,
    }
    try {
      setIsSubmitDisable(true);
      await axios.post(`/v0/factories/${auth.factoryId}/share-processes`, branchData, {
        headers: auth.authorizationHeader
      });
      window.alert("共有が完了しました");
      setIsDataInsert(true)
      setIsModalOpen(false);
    } catch (error: any) {
      window.alert(error.response.data.error)
    }
    setIsSubmitDisable(false);
  };

  useEffect(() => {
    reset({ process_id: process_id, order_number: volume, internal_deadline: process_deadline, product_name: process_name });
    axios.get('/v0/account/factories', {
      headers: auth.authorizationHeader,
      params: { factory_id: auth.factoryId }
    })
      .then((res) => {
        reset({ customer_factory_name: res.data[0].name });
      })
      .catch((err) => {
        console.log(err)
      });
  }, [isModalOpen])


  useEffect(() => {
    if (isModalOpen) {
      open();
    } else if (isOpen) {
      setIsModalOpen(false);
    }
  }, [isModalOpen, isOpen])


  const handleClose = () => {
    setIsModalOpen(false);
    close();
  };
  //modal end


  const parentArray = [
    { title: '', field: 'process_id', default: process_id },
    { title: '', field: 'supplier_id', search: 'suppliers' },
    { title: '連携済仕入先', field: 'supplier_display_id', search: 'suppliers', disable: true, required: true },
    { title: '製作数量', field: 'order_number', default: volume, required: true },
    { title: '依頼納期', field: 'internal_deadline', default: process_deadline, type: 'date', required: true },
    { title: '依頼工程名', field: 'product_name', default: process_name, required: true },
    { title: '自社工場名', field: 'customer_factory_name', required: true },
    { title: 'メモ', field: 'memo', default: 'メモ' }
  ]
  const columnsArray: any = [];
  for (const element of parentArray) {
    if (element.title) {
      columnsArray.push({
        title: element.title,
        field: element.field,
        cellStyle: {
          minWidth: 150,
          maxWidth: 150,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }
      })
    }
  }

  const [selectedFactoryContents, setSelectedFactoryContents] = useState<any>('');

  useEffect(() => {
    setValue('supplier_id', selectedFactoryContents.supplier_id);
    setValue('supplier_display_id', selectedFactoryContents.display_id);
  }, [selectedFactoryContents])

  const listItems = parentArray.map((element: any, index) => {
    if (element.title) {
      return (
        <Fragment key={index}>
          <FormLabelInputWrapper>
            <FormLabel htmlFor={element.field}>{element.title}</FormLabel>
            <FormInput {...register(element.field)}
              {...(element.type && { type: config.inputErrorMessage[element.type].type })}
              {...(element.type && { placeholder: config.inputErrorMessage[element.type].placeholder })}
              {...(element.type && { pattern: config.inputErrorMessage[element.type].pattern })}
              {...(element.type && { title: config.inputErrorMessage[element.type].title })}
              {...(element.required && { required: true })}
              {...(element.disable && { disabled: true })}
              {...(element.type && { maxLength: config.inputErrorMessage[element.type].maxLength })}
              {...(element.type === "number" && { max: config.inputErrorMessage[element.type].max })}
            />
            {element.search === "suppliers" ? <IdSearchButton search={element.search} setSelectedContents={setSelectedFactoryContents} /> : <></>}
          </FormLabelInputWrapper>
        </Fragment>
      )
    }
  });

  return (
    <>
      <Modal>
        <ModalStyle>
          <ModalTitle>{modalTitle}</ModalTitle>
          <ModalForm onSubmit={handleSubmit(onSubmit)}>
            {listItems}
            {isSubmitDisable ? (
              <LoadingContainer>
                <CircularProgress size={20} />
              </LoadingContainer>
            ) : (
              <ModalSubmit type="submit" disabled={isSubmitDisable} />
            )}
          </ModalForm>
          <ModalClose onClick={handleClose}>CLOSE</ModalClose>
        </ModalStyle>
      </Modal>
    </>
  )

}

export default ShareProcesses;